import { BandasClient } from "@/components/bandas/BandasClient";
import { useAuth } from "@/hooks/useAuth";
import { useMemo } from "react";
import { SocialPost, SocialStory } from "@/lib/types";
import { collection, query, where, orderBy, limit } from "firebase/firestore";
import { db } from "@/firebase/config";
import { sanitizeFirestoreData } from "@/lib/utils";
import { useCollection } from "@/firebase/firestore/use-collection";

export default function JartinetBandasPage() {
    const { user, loading: authLoading, jartinetData, handleActionCompletion } = useAuth();

    // Posts recientes para el detalle (filtra por authorId en memoria). Antes leía la
    // colección entera en cada visita; ahora los 250 más recientes ([158]). El historial
    // completo de una banda sigue en su ficha pública (/bandas/:id).
    const postsQuery = useMemo(
        () => query(collection(db, 'social_posts'), orderBy('createdAt', 'desc'), limit(250)),
        []
    );
    const { data: rawPosts } = useCollection<SocialPost>(postsQuery);

    const storiesQuery = useMemo(() => {
        const now = new Date();
        return query(collection(db, 'social_stories'), where('expiresAt', '>', now));
    }, []);
    const { data: rawStories } = useCollection<SocialStory>(storiesQuery);

    const allPosts = useMemo(
        () => (rawPosts || []).map(p => sanitizeFirestoreData(p) as SocialPost),
        [rawPosts]
    );

    const storiesByAuthor = useMemo(() => {
        return (rawStories || []).reduce((acc, story) => {
            const sanitized = sanitizeFirestoreData(story) as SocialStory;
            const key = `${sanitized.authorType}:${sanitized.authorId}`;
            if (!acc[key]) acc[key] = [];
            acc[key].push(sanitized);
            return acc;
        }, {} as Record<string, SocialStory[]>);
    }, [rawStories]);

    if (authLoading) return null;

    return (
        <BandasClient
            initialBandas={jartinetData.bandas || []}
            allUserProfiles={jartinetData.userProfiles || {}}
            allHermandades={jartinetData.hermandades || []}
            allPosts={allPosts}
            initialStories={storiesByAuthor}
            currentUser={user ? { uid: user.uid } : null}
            onAction={handleActionCompletion}
        />
    );
}
